type Level = 'debug' | 'info' | 'warn' | 'error'

// Только технические идентификаторы шагов; OAuth/Stripe URL и данные аккаунта сюда не передаются.
export function onboardingLog(level: Level, event: string, data: Record<string, unknown> = {}) {
  const configured = import.meta.env.VITE_ONBOARDING_LOG_LEVEL ?? (import.meta.env.DEV ? 'debug' : 'warn')
  const levels = ['debug', 'info', 'warn', 'error']
  if (configured === 'off' || levels.indexOf(level) < Math.max(0, levels.indexOf(configured))) return
  console[level](`[Onboarding] ${event}`, data)
}
